import { Box, Typography } from '@material-ui/core'
import { JobProps } from 'common/types'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { PropsWithChildren, useState } from 'react'
import styled, { useTheme } from 'styled-components'
import { StyledNoJob } from '../content/components/jobs/styled'
import MiniJobCard from './components/MiniJobCard'
import Pagination from '@material-ui/lab/Pagination'
import PaginationItem from '@material-ui/lab/PaginationItem'
import { Link } from 'react-router-dom'
import { JobsNotFound } from './components/JobsNotFound'

const NoJobsWrapper = ({ children }: PropsWithChildren<any>) => {
  return (
    <StyledNoJob>
      <Box>
        <b>
          <Typography>{children}</Typography>
        </b>
      </Box>
    </StyledNoJob>
  )
}

export interface IJobsListProps {
  jobsList: JobProps[]
  handleJobClick: (job: string) => void
  currentPage: number
  handlePageChange: (event: any, page: number) => void

  selectedJob?: JobProps
  nopadding?: boolean
  totalPages?: number
  loading?: boolean
}

const StyledPagination = styled(Pagination)`
  & a:not(.Mui-selected) {
    border: 1px solid ${props => props.theme.colors.supplementary1};
    color: ${props => props.theme.colors.accent};
  }

  & .MuiPaginationItem-ellipsis {
    color: ${props => props.theme.colors.accent};
  }
`
const StyledPublicJobsFeedContainer = styled(Box)`
  overflow-y: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const JobsList = ({
  jobsList,
  handleJobClick,
  totalPages = 10,
  selectedJob,
  nopadding,
  handlePageChange,
  currentPage,
  loading
}: IJobsListProps) => {
  const theme = useTheme()
  const { backendUser } = useAuth()
  const { isDevice } = useScreenSizes()

  return (
    <StyledPublicJobsFeedContainer height="100%">
      <Box
        width="100%"
        borderRadius="0.938rem"
        padding={isDevice ? '1.37500rem 0.875rem' : '28px'}
        paddingLeft="1.333em"
        paddingRight="1.333em"
        display="grid"
        gridGap="1.125rem"
      >
        {!!jobsList?.length &&
          jobsList?.map((job, index) => {
            return (
              <MiniJobCard
                user={backendUser}
                job={job}
                theme={theme}
                selected={!isDevice && selectedJob?.id === job?.id}
                handleClick={handleJobClick}
              />
            )
          })}
        {!loading &&
          !jobsList?.length &&
          (isDevice ? (
            <JobsNotFound />
          ) : (
            <Box color={theme.colors.accent1}>
              <Typography>No Results Found</Typography>
            </Box>
          ))}
      </Box>
      {!!jobsList?.length && (
        <Box color={theme.colors.accent} display="flex" justifyContent="center" pb="1.75rem">
          <StyledPagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
            color="primary"
            renderItem={item => (
              <PaginationItem
                component={Link}
                to={`/jobs${item.page === 1 ? '' : `?page=${item.page}`}`}
                {...item}
              />
            )}
          />
        </Box>
      )}
    </StyledPublicJobsFeedContainer>
  )
}
